import axios from 'axios';
import swal from 'sweetalert';
import React,{useEffect,useState} from 'react';
import { Link } from 'react-router-dom';

const Select = () => {
    const [fakultet,setFakultet] = useState([]);
    const [yunalish,setYunalish] = useState([]);
    const [kurs,setKurs] = useState([]);
    const [guruh,setGuruh] = useState([]);
    const [yunID,setYunID] = useState([]);
    const [status, setStatus] = useState(false);
    const [guruhon, setGuruhOn] = useState(false);
    useEffect(() => {
        axios.post("https://tadqiqot-sorovnoma.uz/javohir/surovnoma.uz/admin/Api/select.php",{
            request:"fakultet"
        })
        .then(function (response) {
            setFakultet(response.data.data);
        })
        .catch(function (error) {
        console.log(error);
        });
    },[]);

    let Yunalish = (e) =>{
        setStatus(false);
        var id = e.target.value;
        if(fakultet.length){
            axios.post("https://tadqiqot-sorovnoma.uz/javohir/surovnoma.uz/admin/Api/select.php",{
            request:"yunalish",
            id:id
            })
            .then(function (response) {
                setYunalish(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }

    let Kurs = (e) =>{
        setStatus(false);
        setYunID(e.target.value);
        var k = [1,2,3,4];
        setKurs(k);
    }

    let Guruh = (e) => {
        setStatus(false);
        var kurs = e.target.value;
        if(kurs.length){
            axios.post("https://tadqiqot-sorovnoma.uz/javohir/surovnoma.uz/admin/Api/select.php",{
            request:"guruh",
            id:yunID,
            kurs:kurs
            })
            .then(function (response) {
                setGuruh(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }

    let Test = (e) => {
        var id = e.target.value;
        if(guruh.length){
            setGuruhOn(true);
            axios.post("https://tadqiqot-sorovnoma.uz/javohir/surovnoma.uz/admin/Api/test.php",{
                id:id,
            })
            .then(function (response) {
                let data = response.data.data;
                if(data.status==1){
                    setStatus(true);
                    swal({
                        title: "Good job!",
                        text: "Sizning guruhingizga ruxsat bor",
                        icon: "success",
                        button: "Ok",
                      });
                }else{
                    setStatus(false);
                    swal({
                        title: "Good job!",
                        text: "Sizning guruhingizga ruxsat bor",
                        icon: "error",
                        button: "Ok",
                    });
                }
            })
            .catch(function (error) {
                setStatus(false);
                swal({
                    title: "Good job!",
                    text: "Sizning guruhingizga ruxsat berilmagan",
                    icon: "error",
                    button: "Ok",
                });
            });
        }
    }
    return (
        <div className='select'>
            
            <section className='select_section blur'>
                <div className='select_container container flex center'>
                    <div className='select-group'>
                        {
                            fakultet.length?(
                                <>
                                    <p>Fakultetingizni Tanlang</p>

                                    <select onChange={Yunalish}>
                                        <option>Tanlang</option>
                                        {
                                            fakultet.map((fak) => 
                                                <option value={fak.id} key={fak.id}>{fak.nomi}</option>
                                            )
                                        }
                                    </select>
                                </>
                            ):(
                                <>
                                    Loading...
                                </>
                            )
                        }
                        {
                            yunalish.length?(
                                <>
                                    <p>Yunalishingizni Tanlang</p>
                                    <select onChange={Kurs}>
                                        <option>Tanlang</option>
                                        {
                                            yunalish.map((fak) => 
                                                <option value={fak.id} key={fak.id}>{fak.nomi}</option>
                                            )
                                        }
                                    </select>
                                </>
                            ):(
                                <>
                                    
                                </>
                            )
                        }
                        {
                            kurs.length?(
                                <>
                                    <p>Kursingizni Tanlang</p>
                                    <select onChange={Guruh}>
                                        <option>Tanlang</option>
                                        {
                                            kurs.map((kurs) => 
                                                <option value={kurs} key={kurs}>{kurs}</option>
                                            )
                                        }
                                    </select>
                                </>
                            ):(
                                <>
                                    
                                </>
                            )
                        }
                        {
                            guruh.length?( 
                                <>
                                    <p>Guruhingizni Tanlang</p>
                                    <select onChange={Test}>
                                        <option>Tanlang</option>
                                        {
                                            guruh.map((guruh) => 
                                                <option value={guruh.id} key={guruh.id}>{guruh.nomi}-guruh</option>
                                            )
                                        }
                                    </select>
                                    
                                </>
                            ):(
                                <>
                                </>
                            )
                        }
                        {
                            guruhon?(
                                <>
                                    {
                                        status?(
                                            <Link to="/questions">
                                                <button className='btn btn-succses medium-font-size'>Ishtirok etish</button>
                                            </Link>
                                        ):(
                                            <Link to="/">
                                                <button className='btn btn-succses medium-font-size'>Asosiy sahifa</button>
                                            </Link>
                                        )
                                    }
                                </>
                            ):(
                                <></>
                            )
                        }
                    </div>
                </div>
                
            </section>
        </div>
    );
};


export default Select;